import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  dialogTitleComponent: {
    padding: 0,
  },
  titleContainer: {
    padding: 25,
  },
  titleTypography: {
    fontSize: 24,
  },
  closeIcon: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  dialogContentComponent: {
    flex: 'initial',
  },
  contentContainer: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 3,
    paddingBottom: 20,
    paddingTop: 20,
  },
  contentDescriptionTypography: {
    marginBottom: 30,
  },
  contentText: {
    fontSize: 15,
    fontWeight: 900,
  },
  chooseRulesButtonWrapper: {
    marginTop: 30,
  },
  chooseRulesButton: {
    padding: 10,
  },
  divider: {
    marginTop: 30,
    marginBottom: 30,
  },
  errorWrapper: {
    marginTop: 20,
  },
  error: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    color: '#c21a2d',
  },
  actionsContainer: {
    paddingBottom: 20,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 20,
  },
  cancelActionButton: {
    backgroundColor: theme.palette.common.white,
  },
  deleteGroupTypography: {
    color: theme.palette.error.main,
  },
  popoverItem: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
